import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMegaMenu20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconMegaMenu20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M16.5 4.5h-13a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1M3.5 3A2.5 2.5 0 0 0 1 5.5v9A2.5 2.5 0 0 0 3.5 17h13a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 16.5 3zm.75 3.75A.75.75 0 0 1 5 6h3a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75M5 9a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5zm-.75 3.75A.75.75 0 0 1 5 12h1.5a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75M12 9a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5zm-.75 3.75A.75.75 0 0 1 12 12h1.5a.75.75 0 0 1 0 1.5H12a.75.75 0 0 1-.75-.75M12 6a.75.75 0 0 0 0 1.5h3A.75.75 0 0 0 15 6z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMegaMenu20);
